import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useReactToPrint } from "react-to-print";

const styles = {
  page: { background: "#f0f4f8", minHeight: "100vh", padding: "20px 0" },
  actionBar: { display: "flex", justifyContent: "flex-end", gap: "10px", marginBottom: "20px", padding: "0 16px" },
  btn: { display: "inline-flex", alignItems: "center", gap: "6px", padding: "8px 18px", borderRadius: "6px", fontWeight: 600, fontSize: "13px", cursor: "pointer", border: "none", textDecoration: "none" },
  btnInfo: { background: "#0ea5e9", color: "#fff" },
  btnPrimary: { background: "#2563eb", color: "#fff" },
  btnSecondary: { background: "#64748b", color: "#fff" },
  btnWarning: { background: "#ffc107", color: "#fff" },
  invoiceWrap: { maxWidth: "820px", margin: "0 auto", fontFamily: "'Segoe UI', Arial, sans-serif" },
  invoiceCard: { background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.12)", marginBottom: "28px" },

  /* Header */
  invoiceHeader: { background: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #0ea5e9 100%)", padding: "32px 40px 28px", display: "flex", justifyContent: "space-between", alignItems: "flex-start" },
  invoiceTitleBlock: {},
  invoiceLabel: { fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase", color: "rgba(255,255,255,0.7)", marginBottom: "4px" },
  invoiceTitle: { fontSize: "36px", fontWeight: 900, color: "#fff", letterSpacing: "2px", lineHeight: 1 },
  invoiceTagline: { fontSize: "12px", color: "rgba(255,255,255,0.65)", marginTop: "6px" },
  agencyBlock: { textAlign: "right", color: "#fff" },
  agencyName: { fontSize: "18px", fontWeight: 800 },
  agencyInfo: { fontSize: "12px", color: "rgba(255,255,255,0.75)", marginTop: "6px", lineHeight: 1.7 },
  hotelWatermark: { fontSize: "80px", opacity: 0.08, position: "absolute", right: "180px", top: "10px", pointerEvents: "none", userSelect: "none" },

  /* Meta bar */
  metaBar: { background: "#1e3a8a", padding: "14px 40px", display: "flex", gap: "40px", flexWrap: "wrap", borderBottom: "3px solid #f59e0b" },
  metaItem: { color: "#93c5fd", fontSize: "10px", letterSpacing: "1px", textTransform: "uppercase" },
  metaValue: { color: "#fff", fontWeight: 700, fontSize: "14px", marginTop: "3px" },

  /* Body */
  invoiceBody: { padding: "32px 40px" },
  twoCol: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", marginBottom: "28px" },
  infoBox: { background: "#f8fafc", borderRadius: "10px", padding: "16px 20px", border: "1px solid #e2e8f0" },
  infoBoxTitle: { fontSize: "10px", letterSpacing: "2px", textTransform: "uppercase", color: "#94a3b8", fontWeight: 700, marginBottom: "8px" },
  infoLine: { fontSize: "13px", color: "#1e293b", marginBottom: "4px", fontWeight: 500 },
  infoLineBold: { fontSize: "14px", color: "#1e3a8a", fontWeight: 800 },

  /* stay details */
  stayBox: { border: "1px solid #e2e8f0", borderRadius: "12px", padding: "16px 20px", marginBottom: "24px", background: "#ffffff" },
  stayGrid: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px" },

  /* Divider */
  divider: { border: "none", borderTop: "1px solid #f1f5f9", margin: "24px 0" },
  sectionTitle: { fontSize: "13px", fontWeight: 700, color: "#1e3a8a", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "12px", display: "flex", alignItems: "center", gap: "8px" },

  /* Tables */
  table: { width: "100%", borderCollapse: "collapse", marginBottom: "24px", pageBreakInside: "avoid", breakInside: "avoid" },
  th: { background: "#1e3a8a", color: "#fff", fontSize: "11px", letterSpacing: "1px", textTransform: "uppercase", padding: "10px 14px", textAlign: "left", fontWeight: 700 },
  td: { padding: "10px 14px", fontSize: "13px", color: "#1e293b", borderBottom: "1px solid #f1f5f9", fontWeight: 500 },
  typeBadge: { background: "#eff6ff", color: "#1d4ed8", borderRadius: "4px", padding: "2px 8px", fontSize: "11px", fontWeight: 700 },

  /* Price summary */
  priceBox: { background: "#f8fafc", borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden", marginLeft: "auto", minWidth: "300px", pageBreakInside: "avoid", breakInside: "avoid" },
  priceHeader: { background: "#1e3a8a", color: "#fff", padding: "10px 20px", fontSize: "12px", letterSpacing: "2px", textTransform: "uppercase", fontWeight: 700 },
  priceRow: { display: "flex", justifyContent: "space-between", padding: "10px 20px", borderBottom: "1px solid #e2e8f0", fontSize: "13px", color: "#334155" },
  priceRowTotal: { display: "flex", justifyContent: "space-between", padding: "14px 20px", background: "#1e3a8a", fontSize: "16px", color: "#fff", fontWeight: 800 },
  priceLabel: { color: "#64748b" },
  priceValue: { fontWeight: 600, color: "#1e293b" },
  discountValue: { fontWeight: 600, color: "#16a34a" },

  /* Footer */
  invoiceFooter: { background: "#f8fafc", borderTop: "3px solid #1e3a8a", padding: "20px 40px", display: "flex", justifyContent: "space-between", alignItems: "center", pageBreakInside: "avoid", breakInside: "avoid" },
  footerNote: { fontSize: "11px", color: "#94a3b8", maxWidth: "400px", lineHeight: 1.6 },
  footerBrand: { textAlign: "right" },
  footerBrandName: { fontWeight: 800, fontSize: "16px", color: "#1e3a8a" },
  footerBrandSub: { fontSize: "11px", color: "#94a3b8" },
  infoSection: { background: "#fff", borderTop: "2px solid #e2e8f0", padding: "24px 40px", fontFamily: "'Segoe UI', Arial, sans-serif", pageBreakInside: "avoid", breakInside: "avoid" },
  infoTitleBar: { background: "#000", color: "#fff", padding: "8px 16px", fontSize: "13px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "14px" },
  infoList: { paddingLeft: "0", listStyleType: "none", marginBottom: "0" },
  infoListItem: { fontSize: "11.5px", color: "#334155", marginBottom: "6px", lineHeight: "1.5", paddingLeft: "4px" }
};

const HotelInvoice = () => {
  const params = useParams();
  const navigate = useNavigate();
  const contentRef = useRef();
  const [pageLoading, setPageLoading] = useState(false);
  const { user, loading } = useAuth();
  const [hotelBooking, setHotelBooking] = useState("");
  const [hotel, setHotel] = useState({});
  const [rooms, setRooms] = useState([]);
  const [guests, setGuests] = useState([]);
  const [nights, setNights] = useState(1);

  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
  });

  const handlePDF = () => {
    const input = contentRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save((hotelBooking.travellerName || "hotel") + "_booking_invoice.pdf");
    });
  };

  const GetData = () => {
    setPageLoading(true);
    apiService
      .getAll(config.GETHOTELBOOKINGDETAILS + "/" + params.hotelBookingId)
      .then((res) => {
        setHotelBooking(res.data);
        setHotel(res.data.hotelDetails);
        setRooms(res.data.hotelRoomDetails.requestedHotels);
        setGuests(res.data.hotelGuestInfos);

        // Dynamically compute stay nights on mount [2]
        const cin = new Date(res.data.checkIn);
        const cout = new Date(res.data.checkOut);
        const diffNights = Math.ceil(Math.abs(cout - cin) / (1000 * 60 * 60 * 24));
        setNights(diffNights || 1);

        setPageLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching company data", err);
        setPageLoading(false);
      });
  };

  useEffect(() => {
    GetData();
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
    return null;
  }

  // --- Dynamic Pricing Calculations (netPrice from response maps baseFare) --- [2]
  const baseFare = parseFloat(hotelBooking.netPrice || 0); 
  const hotelTax = parseFloat(hotelBooking.hotelRoomDetails?.taxAndFee || 0);
  const tcsAmount = parseFloat(hotelBooking.tcsAmount || 0);
  const convinFee = parseFloat(hotelBooking.convenienceFee || 0);
  const pgAmount = parseFloat(hotelBooking.paymentGatewayAmount || 0);
  const discountVal = parseFloat(hotelBooking.discount || 0);
  const markupVal = parseFloat(hotelBooking.markup || 0);
  const totalPrice = parseFloat(hotelBooking.totalPrice || 0);

  // Platform Fee (calculated dynamically) [2]
  const platformFee = Math.max(0, totalPrice - baseFare - hotelTax - tcsAmount - convinFee - markupVal - pgAmount + discountVal);
  const calculatedTotalAgent = totalPrice - markupVal;

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid" style={{ background: "#f0f4f8" }}>
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body" style={styles.page}>
                  {pageLoading === true ? (
                    <div className="row align-items-center justify-content-center">
                      <div className="col-lg-12">
                        <img
                          src="/assets/images/loader.webp"
                          width={"64px"}
                          height={"64px"}
                          alt="loading"
                          loading="lazy"
                        />
                        Loading, Please wait...
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* Action buttons bar */}
                      <div style={styles.actionBar} className="d-print-none">
                        <Link style={{ ...styles.btn, ...styles.btnInfo }} onClick={handlePrint}>
                          <i className="ri-printer-line"></i> Print
                        </Link>
                        {/* Fixed broken link parameter referencing flight instead of hotel */}
                        <Link to={"/hotel/voucher/" + params.hotelBookingId} style={{ ...styles.btn, ...styles.btnPrimary }}>
                          <i className="ri-file-text-line"></i> View Voucher
                        </Link>
                        <Link style={{ ...styles.btn, ...styles.btnSecondary }} onClick={handlePDF}>
                          <i className="ri-download-2-line"></i> Download Invoice
                        </Link>
                         <Link to={"/hotel/customer-invoice/" + params.hotelBookingId} style={{ ...styles.btn, ...styles.btnInfo }}>
                          <i className="ri-file-text-line"></i> View Customer Invoice
                        </Link>
                      </div>

                      {/* Main Printable Area */}
                      <div ref={contentRef} style={styles.invoiceWrap}>
                        <div style={styles.invoiceCard}>
                          
                          {/* Invoice Header */}
                          <div style={{ ...styles.invoiceHeader, position: "relative" }}>
                            <div style={styles.hotelWatermark}>🏨</div>
                            <div style={styles.invoiceTitleBlock}>
                              <div style={styles.invoiceLabel}>Travel Agency</div>
                              <div style={styles.invoiceTitle}>INVOICE</div>
                              <div style={styles.invoiceTagline}>🏨 Hotel Booking Tax Invoice</div>
                            </div>
                            <div style={styles.agencyBlock}>
                              <div style={styles.agencyName}>{user?.companyname}</div>
                              <div style={styles.agencyInfo}>
                                {user?.email}<br />
                                {user?.phoneNumber}<br />
                                GST: {user?.companygstno}
                              </div>
                            </div>
                          </div>

                          {/* Meta Bar */}
                          <div style={styles.metaBar}>
                            {hotelBooking.bookingNo && (
                              <div style={styles.metaItem}>
                                Invoice / Booking No
                                <div style={styles.metaValue}>{hotelBooking.bookingNo}</div>
                              </div>
                            )}
                            <div style={styles.metaItem}>
                              Invoice Date
                              <div style={styles.metaValue}>
                                {hotelBooking.bookingDate ? moment(hotelBooking.bookingDate).format("DD MMM YYYY") : moment().format("DD MMM YYYY")}
                              </div>
                            </div>
                            {hotelBooking.hotelBookingId && (
                              <div style={styles.metaItem}>
                                Booking ID
                                <div style={styles.metaValue}>{hotelBooking.hotelBookingId.substring(0, 8).toUpperCase()}</div>
                              </div>
                            )}
                            {hotelBooking.paymentStatus && (
                              <div style={styles.metaItem}>
                                Payment Status
                                <div style={styles.metaValue}>{hotelBooking.paymentStatus}</div>
                              </div>
                            )}
                          </div>

                          {/* Body */}
                          <div style={styles.invoiceBody}>
                            
                            {/* Billed To / Hotel Summary */}
                            <div style={styles.twoCol}>
                              <div style={styles.infoBox}>
                                <div style={styles.infoBoxTitle}>Billed To</div>
                                <div style={styles.infoLineBold}>{hotelBooking.travellerName}</div>
                                {hotelBooking.travellerEmail && <div style={styles.infoLine}>Email: {hotelBooking.travellerEmail}</div>}
                                {hotelBooking.travellerMobile && <div style={styles.infoLine}>Mobile: {hotelBooking.travellerMobile}</div>}
                              </div>
                              <div style={styles.infoBox}>
                                <div style={styles.infoBoxTitle}>Payment Summary</div>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                                  <span style={{ fontSize: "13px", color: "#64748b" }}>Total Amount</span>
                                  <span style={{ fontSize: "15px", fontWeight: 800, color: "#1e3a8a" }}>
                                    INR {Math.round(calculatedTotalAgent)?.toLocaleString("en-IN")} INR
                                  </span>
                                </div>
                                <div style={{ fontSize: "11px", color: "#94a3b8" }}>
                                  Includes all taxes &amp; fees
                                </div>
                                <div style={{ marginTop: "8px" }}>
                                  <span style={{ background: hotelBooking.bookingStatus === "FAILED" ? "#fee2e2" : "#dcfce7", color: hotelBooking.bookingStatus === "FAILED" ? "#991b1b" : "#15803d", borderRadius: "6px", padding: "3px 10px", fontSize: "11px", fontWeight: 700 }}>
                                    {hotelBooking.bookingStatus}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Stay Details */}
                            <div style={styles.sectionTitle}>
                              <span>🏨</span> Hotel &amp; Stay Details
                            </div>
                            <div style={styles.stayBox}>
                              <div style={styles.stayGrid}>
                                <div>
                                  <small style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase' }}>Check-In</small>
                                  <div style={{ fontSize: '15px', fontWeight: 700, color: '#0f172a' }}>
                                    {moment(hotelBooking.checkIn).format("DD MMM YYYY")}
                                  </div>
                                  <small style={{ color: '#64748b' }}>{hotel.checkInTime || "12:00 PM"}</small>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                  <small style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase' }}>Stay Duration</small>
                                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#2563eb' }}>
                                    {nights} Night{nights > 1 ? 's' : ''}
                                  </div>
                                  <small style={{ color: '#64748b' }}>{hotelBooking.noOfRooms} Room{hotelBooking.noOfRooms > 1 ? 's' : ''}</small>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                  <small style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase' }}>Check-Out</small>
                                  <div style={{ fontSize: '15px', fontWeight: 700, color: '#0f172a' }}>
                                    {moment(hotelBooking.checkOut).format("DD MMM YYYY")}
                                  </div>
                                  <small style={{ color: '#64748b' }}>{hotel.checkOutTime || "12:00 PM"}</small>
                                </div>
                              </div>
                              <div style={{ marginTop: "14px", paddingTop: "12px", borderTop: "1px dashed #e2e8f0" }}>
                                <small style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', display: 'block' }}>Address</small>
                                <span style={{ fontSize: '12.5px', color: '#334155', fontWeight: 500 }}>
                                  {/* Gracefully falls back to root location properties if dynamic hotel details are null [2] */}
                                  {hotel.address ? `${hotel.address}, ` : ""}
                                  {hotel.cityName || hotelBooking.city ? `${hotel.cityName || hotelBooking.city}, ` : ""}
                                  {hotel.countryName || hotelBooking.country || ""}
                                </span>
                              </div>
                            </div>

                            {/* Rooms Table */}
                            <div style={styles.sectionTitle}>
                              <span>🛌</span> Room Details
                            </div>
                            <table style={styles.table}>
                              <thead>
                                <tr>
                                  <th style={styles.th}>#</th>
                                  <th style={styles.th}>Room Type</th>
                                  <th style={styles.th}>Guests Allocation</th>
                                  <th style={styles.th}>Meal Type</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rooms.length > 0 && rooms.map((v, index) => (
                                  <tr key={index} style={index % 2 === 1 ? { background: "#f8fafc" } : {}}>
                                    <td style={styles.td}>{index + 1}</td>
                                    <td style={{ ...styles.td, fontWeight: 700 }}>{v.roomType}</td>
                                    <td style={styles.td}>Adults: {v.adults} {v.kids > 0 && `, Kids: ${v.kids}`}</td>
                                    <td style={styles.td}>
                                      <span style={styles.typeBadge}>{v.mealType || "Room Only"}</span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            {/* Guests Table */}
                            <div style={styles.sectionTitle}>
                              <span>👤</span> Guest Details
                            </div>
                            <table style={styles.table}>
                              <thead>
                                <tr>
                                  <th style={styles.th}>#</th>
                                  <th style={styles.th}>Guest Name</th>
                                  <th style={styles.th}>Type</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(() => {
                                  let idx = 1;
                                  return guests.map((raa) => (
                                    <React.Fragment key={idx}>
                                      {raa.adultsFields.map((ra, aIdx) => (
                                        <tr key={`adult-${idx}`} style={idx % 2 === 0 ? { background: "#f8fafc" } : {}}>
                                          <td style={styles.td}>{idx++}</td>
                                          <td style={{ ...styles.td, fontWeight: 700 }}>{ra.title}. {ra.firstName} {ra.lastName}</td>
                                          <td style={styles.td}>
                                            <span style={styles.typeBadge}>{ra.travelerType}</span>
                                          </td>
                                        </tr>
                                      ))}
                                      {raa.kidsFields.map((rk, kIdx) => (
                                        <tr key={`kid-${idx}`} style={idx % 2 === 0 ? { background: "#f8fafc" } : {}}>
                                          <td style={styles.td}>{idx++}</td>
                                          <td style={{ ...styles.td, fontWeight: 700 }}>{rk.title}. {rk.firstName} {rk.lastName}</td>
                                          <td style={styles.td}>
                                            <span style={styles.typeBadge}>{rk.travelerType}</span>
                                          </td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ));
                                })()}
                              </tbody>
                            </table>

                            <hr style={styles.divider} />

                            {/* Fare Breakdown */}
                            <div style={styles.sectionTitle}>
                              <span>INR</span> Fare Breakdown
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                              <div style={styles.priceBox}>
                                <div style={styles.priceHeader}>Price Summary</div>
                                
                                <div style={styles.priceRow}>
                                  <span style={styles.priceLabel}>Base Price</span>
                                  <span style={styles.priceValue}>INR {Math.round(baseFare)?.toLocaleString("en-IN")}</span>
                                </div>

                                {hotelTax > 0 && (
                                  <div style={styles.priceRow}>
                                    <span style={styles.priceLabel}>Hotel Taxes</span>
                                    <span style={styles.priceValue}>INR {Math.round(hotelTax)?.toLocaleString("en-IN")}</span>
                                  </div>
                                )}

                                <div style={styles.priceRow}>
                                  <span style={styles.priceLabel}>Platform Fee (18% GST Included)</span>
                                  <span style={styles.priceValue}>INR {Math.round(platformFee)?.toLocaleString("en-IN")}</span>
                                </div>

                                {tcsAmount > 0 && (
                                  <div style={styles.priceRow}>
                                    <span style={styles.priceLabel}>TCS (claimable during ITR)</span>
                                    <span style={styles.priceValue}>INR {Math.round(tcsAmount)?.toLocaleString("en-IN")}</span>
                                  </div>
                                )}

                                {convinFee > 0 && (
                                  <div style={styles.priceRow}>
                                    <span style={styles.priceLabel}>Convenience Fee (18% GST Included)</span>
                                    <span style={styles.priceValue}>INR {Math.round(convinFee)?.toLocaleString("en-IN")}</span>
                                  </div>
                                )}

                                {pgAmount > 0 && (
                                  <div style={styles.priceRow}>
                                    <span style={styles.priceLabel}>Payment Gateway Fee</span>
                                    <span style={styles.priceValue}>INR {pgAmount.toFixed(2)}</span>
                                  </div>
                                )}
                                
                                {discountVal > 0 && (
                                  <div style={styles.priceRow}>
                                    <span style={{ color: "#16a34a", fontWeight: 600 }}>Discount</span>
                                    <span style={styles.discountValue}>- INR {discountVal?.toLocaleString("en-IN")}</span>
                                  </div>
                                )}
                                
                                <div style={styles.priceRowTotal}>
                                  <span>Total Payable</span>
                                  <span>INR {Math.round(calculatedTotalAgent)?.toLocaleString("en-IN")} INR</span>
                                </div>
                              </div>
                            </div>

                          </div>

                          {/* Important Guidelines Section */}
                          <div style={styles.infoSection}>
                            <div style={styles.infoTitleBar}>Important Information</div>
                            <ul style={styles.infoList}>
                              <li style={styles.infoListItem}>1 - Check-in time is typically from 2:00 PM and check-out time is by 12:00 PM. Early check-in or late check-out is subject to availability and hotel discretion.</li>
                              <li style={styles.infoListItem}>2 - All guests must present a valid government-issued photo ID (Passport, Aadhaar, Driving License) at check-in. PAN cards are not accepted as valid ID proof.</li>
                              <li style={styles.infoListItem}>3 - The primary guest checking in must be at least 18 years of age.</li>
                              <li style={styles.infoListItem}>4 - Any auxiliary hotel charges, security deposits, or city taxes must be paid directly to the property in local currency.</li>
                              <li style={styles.infoListItem}>5 - Booking cancellations and modifications are subject to the specific room's cancel policy and fare rules selected at the time of booking.</li>
                              <li style={styles.infoListItem}>6 - Use the Booking / Invoice No for all correspondence directly with the hotel.</li>
                            </ul>
                          </div>

                          {/* Footer */}
                          <div style={styles.invoiceFooter}>
                            <div style={styles.footerNote}>
                              This is a computer-generated invoice. No signature is required. For queries, contact us at {user?.email}.
                              All prices are inclusive of applicable taxes.
                            </div>
                            <div style={styles.footerBrand}>
                              <div style={styles.footerBrandName}>{user?.companyname}</div>
                              <div style={styles.footerBrandSub}>Authorized Travel Agency &bull; {moment().format("YYYY")}</div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelInvoice;